var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({staticClass:"l-divider",class:_vm.border_style},'div',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }